import { gql } from '@apollo/client/core';

export const COURSE_PROGRESS_QUERY = gql`
    query CourseProgress($courseSubscriptionSessionId: ID!) {
        courseProgress(courseSubscriptionSessionId: $courseSubscriptionSessionId) {
            totalUnits
            completedUnits
            progressPercent
            sections {
                id
                title
                totalUnits
                completedUnits
                progressPercent
                units {
                    sectionContentId
                    doneAt
                    duration
                }
            }
        }
    }
`;

export interface UnitProgress {
    sectionContentId: string;
    doneAt: string | null;
    duration: number;
}

export interface SectionProgress {
    id: string;
    title: string;
    totalUnits: number;
    completedUnits: number;
    progressPercent: number;
    units: UnitProgress[];
}

export interface CourseProgressResult {
    totalUnits: number;
    completedUnits: number;
    progressPercent: number;
    sections: SectionProgress[];
}

export interface CourseProgressResponse {
    courseProgress: CourseProgressResult;
}
